<template>
    <div class="item item-engagement-ring">
        <Image
            v-if="image"
            class="image"
            loading="lazy"
            :alt="title"
            v-bind="getImageProps(image, ['36px'])"
        />

        <div class="title-description">
            <h3 class="title">
                {{ title }}
            </h3>

            <div class="description">
                {{ description }}
            </div>
        </div>

        <div
            v-if="!fetchingRingBuilderSetMutation"
            class="remove-button"
            @click.prevent.stop="removeRing"
        >
            {{ t('ring_builder.remove') }}
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { RingBuilderMountEngagementRingFragment } from '@/graphql/api'

import Image from '@/components/Image.vue'
import { getImageProps } from '@/components/getImageProps.ts'
import { useI18n } from 'vue-i18n'
import { useRingBuilder } from '@/plugins/ring-builder.ts'
const props = defineProps<{
    data: RingBuilderMountEngagementRingFragment
}>()

const {
    removeRing,
    ringTotalSaleAmountFormatted,
    fetchingRingBuilderSetMutation,
    image,
} = useRingBuilder()

const title = computed(
    () =>
        `${props.data.centreStoneConstraints.shape.translation.name} ${props.data.productName}`
)

const description = computed(
    () =>
        `${props.data.primaryMetal.translation.name}: ${ringTotalSaleAmountFormatted.value}`
)

const { t } = useI18n()
</script>

<style lang="scss" scoped src="./ringBuilderItem.scss"></style>
<style lang="scss" scoped>
.item-engagement-ring {
    .image {
        margin-right: 20px;
        width: 36px;

        @include min-width(1024) {
            width: 36px;
        }
    }
}
</style>
